module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"ngFormly","amd":"angular-formly","commonjs2":"angular-formly","commonjs":"angular-formly"}
 ** module id = 2
 ** module chunks = 0
 **/